import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { getConstructionApiUrl } from '@adsk/acs-admin-ui-components-helpers';
import { PRODUCT_IDS } from '@adsk/alloy-provider';

export const buildCreateProjectUsersRequest = (
  projectId,
  usersData,
  useConstructionApi = false
) => {
  const url = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();

  return [
    `${url}/v1/projects/${projectId}/users:import`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(usersData),
    },
  ];
};

export const buildProductProjectTrialAccess = (productIds) => {
  const access = [];

  productIds.forEach((productId) => {
    if (
      productId === PRODUCT_IDS.COST ||
      productId === PRODUCT_IDS.BUILD ||
      productId === PRODUCT_IDS.INSIGHT ||
      productId === PRODUCT_IDS.PROJECT_ADMINISTRATION
    ) {
      access.push({
        key: productId,
        access: 'administrator',
      });
    }
  });

  return access;
};

export const buildGetProjectRequest = (projectId) => {
  const url = getConstructionApiUrl();

  return `${url}/v1/projects/${projectId}`;
};
